export default "https://cdn-static.gokick.com/assets/0488227f5b7e53bbf90738be35137ce008cd4a94/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";